const _setButtons = (element, dataTrackClickBase) => {
  let buttons = element.querySelectorAll('[data-component="Button"]');

  buttons.forEach(function(button) {
    button.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        `Button ${button.getAttribute('data-type')}` || 'Undefined Button Type',
        button.innerText || 'Undefined Inner Text',
        button.getAttribute('data-uuid') || 'Undefined UUID'
      ].join(', ')
    );
  });
};

const _setLinks = (element, dataTrackClickBase) => {
  let links = element.querySelectorAll('a:not([data-track-click])');

  links.forEach(function(link) {
    link.setAttribute(
      'data-track-click',
      [dataTrackClickBase, 'Link', link.innerText || 'Undefined Inner Text'].join(', ')
    );
  });
};

const _setCopyLinks = (element, dataTrackClickBase) => {
  let links = element.querySelectorAll('[data-component="Copy Link"]');

  links.forEach(function(link) {
    link.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        'Copy Link',
        link.innerText || 'Undefined Inner Text',
        link.getAttribute('data-uuid') || 'Undefined UUID'
      ].join(', ')
    );
  });
};

const _setImages = (element, dataTrackClickBase) => {
  let imageLinks = element.querySelectorAll('[data-component="Image-Link"]');

  imageLinks.forEach(function(imageLink) {
    imageLink.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        `${imageLink.getAttribute('data-type')} Image Link` || 'Undefined Type',
        imageLink.getAttribute('data-alt') || 'Undefined Alt',
        imageLink.getAttribute('data-uuid') || 'Unknown UUID'
      ].join(', ')
    );
  });
};

const _setLinkedIcons = (element, dataTrackClickBase) => {
  let linkedIconNameLinks = element.querySelectorAll('[data-component="Linked Icon Name Link"]');
  let linkedIconLearnMoreLinks = element.querySelectorAll('[data-component="Linked Icon Learn More Link"]');

  linkedIconNameLinks.forEach(function(linkedIcon) {
    linkedIcon.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        'Linked Icon Name Link',
        linkedIcon.getAttribute('data-name') || 'Undefined Name',
        linkedIcon.getAttribute('data-uuid') || 'Undefined uuid'
      ].join(', ')
    );
  });

  linkedIconLearnMoreLinks.forEach(function(linkedIcon) {
    linkedIcon.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        'Linked Icon Learn More Link',
        linkedIcon.getAttribute('data-name') || 'Undefined Name',
        linkedIcon.getAttribute('data-uuid') || 'Undefined uuid'
      ].join(', ')
    );
  });
};

const _setMarketPlaceHighlights = (element, dataTrackClickBase) => {
  let highlights = element.querySelectorAll('.marketplace-highlights .highlight');

  highlights.forEach(function(highlight) {
    highlight.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        'Marketplace Highlight',
        highlight.getAttribute('data-name') || 'Undefined Name',
        highlight.getAttribute('data-uuid') || 'Undefined UUID'
      ].join(', ')
    );
  });
};

const _setResourceTiles = (element, dataTrackClickBase) => {
  element.querySelectorAll('.card').forEach(function(card) {
    let headline = _findFirstHeadline(card);
    let dataType = card.getAttribute('data-type') !== null ? card.getAttribute('data-type').trim() : 'Unknown Type';

    card.setAttribute(
      'data-track-click',
      [`${dataTrackClickBase} Card`, dataType, headline, card.getAttribute('data-uuid') || 'Undefined UUID'].join(', ')
    );
  });
};

const _setYoutubeComponents = (element, dataTrackClickBase) => {
  let youtubeElements = element.querySelectorAll('[data-component="YouTube Video Component"]');

  youtubeElements.forEach(function(linkedIcon) {
    linkedIcon.setAttribute(
      'data-track-click',
      [
        dataTrackClickBase,
        'YouTube Video Component',
        linkedIcon.getAttribute('data-embed') || 'Undefined YouTube ID',
        linkedIcon.getAttribute('data-uuid') || 'Undefined uuid'
      ].join(', ')
    );
  });
};

const _findFirstHeadline = element => {
  let headline = '';

  for (let headingSize = 1; headingSize <= 7 && !headline.length; headingSize++) {
    if (element.querySelector(`h${headingSize}`)) {
      headline = element.querySelector(`h${headingSize}`).innerText;
    }
  }

  return headline.length ? headline.trim() : 'Undefined Headline';
};

module.exports = {
  setDataTrackClicks: () => {
    const sections = document.querySelectorAll('[data-set-track-clicks]');

    sections.forEach(function(section) {
      const dataTrackClickBase = section.getAttribute('data-set-track-clicks');

      _setButtons(section, dataTrackClickBase);
      _setCopyLinks(section, dataTrackClickBase);
      _setImages(section, dataTrackClickBase);
      _setLinkedIcons(section, dataTrackClickBase);
      _setMarketPlaceHighlights(section, dataTrackClickBase);
      _setResourceTiles(section, dataTrackClickBase);
      _setYoutubeComponents(section, dataTrackClickBase);
      _setLinks(section, dataTrackClickBase);

      switch (dataTrackClickBase) {
        case 'Testimonial Slider Section':
          section.querySelectorAll('.case-study-link').forEach(function(caseStudyLink) {
            caseStudyLink.setAttribute(
              'data-track-click',
              [
                dataTrackClickBase,
                'Case Study Link',
                caseStudyLink.getAttribute('data-company') || 'Undefined Company',
                caseStudyLink.getAttribute('data-uuid') || 'Undefined UUID'
              ].join(', ')
            );
          });
          break;

        case 'Subnav':
          section.querySelectorAll('.global-subnav .subnav__link').forEach(function(subNavLink) {
            subNavLink.setAttribute(
              'data-track-click',
              [
                dataTrackClickBase,
                'Link',
                subNavLink.innerText || 'Unknown Link Text',
                subNavLink.getAttribute('data-uuid') || 'Undefined UUID'
              ].join(', ')
            );
          });
          break;
      }
    });
  }
};
